(($, Drupal) => {
  Drupal.behaviors.articleFontsize = {
    attach: function attch(context) {
      $('.article-fontsize__wrapper', context).once('articleFontsize').each((index, element) => {
        const $sizePlus = $(element).find('.js-size-plus');
        const $sizeMinus = $(element).find('.js-size-minus');
        const $textElement = $('.article-media__wrapper, .article-text__wrapper, .article-data__heading');
        let $currentTxtSize = 1;

        function modifyFontSize(flag) {
          if (flag === 'increase') {
            $currentTxtSize += 0.1;
          } else if (flag === 'decrease') {
            $currentTxtSize -= 0.1;
          }
          $textElement.css('font-size', `${$currentTxtSize}em`);
        }

        $sizePlus.on('click', () => {
          modifyFontSize('increase');
        });

        $sizeMinus.on('click', () => {
          modifyFontSize('decrease');
        });
      });
    },
  };
})(jQuery, Drupal);
